import {
	LOADING_BEGIN,
	LOADING_END,
	LOAD_FILE_SUCCESS,
	LOAD_FILE_ERROR,
	FILE_BLOB,
	FILE_HEADERS_EXIST,
	FILE_HEADERS,
	FILE_ROWS,
	SET_FILENAME,
	SELECTED_COLUMNS,
	FORMULA_UPDATE,
	AXIS_LABEL
} from '../redux/file-actions';

export default function fileContents(
	state = {
		xFile: {
			fileContent : [],
			filename: "",
			fileBlob: null,
			error: null,
			isLoading: false,
			isLoaded: true,
			headersExist: false,
			headers: [],
			tableRows: [],
			selectedColumns: [],
			formula: "",
			firstRow: [],
			axisLabel: "x",
		},
		yFile: {
			fileContent : [],
			filename: "",
			fileBlob: null,
			error: null,
			isLoading: false,
			isLoaded: true,
			headersExist: false,
			headers: [],
			tableRows: [],
			selectedColumns: [],
			formula: "",
			firstRow: [],
			axisLabel: "y",
		},
		zFile: {
			fileContent : [],
			filename: "",
			fileBlob: null,
			error: null,
			isLoading: false,
			isLoaded: true,
			headersExist: false,
			headers: [],
			tableRows: [],
			selectedColumns: [],
			formula: "",
			firstRow: [],
			axisLabel: "z",
		}
	},
	action) {
	let update = {};
	switch(action.type) {
		case LOADING_BEGIN:
			update.isLoading = true;
			break;

		case LOADING_END:
			update.isLoading = false;
			break;

		case LOAD_FILE_SUCCESS:
			update = {
				fileContent: action.response,
				headers: action.headers,
				isLoaded: true,
				error: null,
			};
			break;

		case LOAD_FILE_ERROR:
			update = {
				error: action.error,
				isLoaded: false,
			};
			break;

		case FILE_BLOB:
			update.fileBlob = action.blob;
			break;

		case FILE_HEADERS_EXIST:
			update = {
				headersExist: action.headersExist,
				selectedColumns: []
			};
			break;

		case FILE_HEADERS:
			update.headers = action.headers;
			break;

		case FILE_ROWS:
			update = {
				tableRows: action.rows,
				firstRow: action.rows.length > 0 ? action.rows[0] : [],
			};
			break;

		case SET_FILENAME:
			update = {
				filename: action.filename,
				isLoaded: action.isLoaded,
			};
			break;

		case SELECTED_COLUMNS:
			update.selectedColumns = action.value;
			break;
		
		case FORMULA_UPDATE:
			update.formula = action.formula;
			break;
		case AXIS_LABEL:
			update.axisLabel = action.label;
			break;
		default:
			return state;
	}
	
	let fileObj = Object.assign({}, state[action.fileId], update);

	let newState = {};
	newState[action.fileId] = fileObj;

	return Object.assign({}, state, newState);
}


// WEBPACK FOOTER //
// ./src/redux/file-reducer.js